import { render } from "./DepartamentoList.vue?vue&type=template&id=1d2ce1f2&scoped=true"
import script from "./DepartamentoList.vue?vue&type=script&lang=js"
export * from "./DepartamentoList.vue?vue&type=script&lang=js"

import "./DepartamentoList.vue?vue&type=style&index=0&id=1d2ce1f2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d2ce1f2"]])

export default __exports__